import { JoggOrder } from "@jog/types"

import { gtmPush } from "./index"

export const gtmNewsletterSubscription = () => {
    gtmPush({ event: "newsletter_subscription", formLocation: "widget_homepage" })
}

export const gtmPageTracking = (gtmTypeOfPage: string) => {
    gtmPush({ ecomm_pagetype: gtmTypeOfPage || "other" })
}

export const gtmAddUserId = (userId: string) => {
    if (userId) gtmPush({ "user-id": userId })
}

export const gtmEnhancedConversion = (paymentOrderInfo: JoggOrder) => {
    const email = paymentOrderInfo?.billingAddress?.email
    if (!email) return
    gtmPush({ email, event: "fireEnhancedConversionTag" })
}
